// Message types
export const MESSAGE_TYPES = {
  SUCCESS: 'success',
  INFO: 'info',
  WARNING: 'warning',
  ERROR: 'error'
};

// Notification types
export const NOTIFICATION_TYPES = {
  BOOKING: 'booking',
  REMINDER: 'reminder',
  UPDATE: 'update',
  PROMOTION: 'promotion',
  SECURITY: 'security'
};

// Booking statuses
export const BOOKING_STATUS = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  CANCELLED: 'cancelled',
  COMPLETED: 'completed'
};

// Passenger types
export const PASSENGER_TYPES = {
  ADULT: 'adult',
  CHILD: 'child',
  INFANT: 'infant'
};

// Travel preferences
export const SEAT_PREFERENCES = {
  WINDOW: 'window',
  AISLE: 'aisle',
  MIDDLE: 'middle',
  NO_PREFERENCE: 'no-preference'
};

export const MEAL_PREFERENCES = {
  STANDARD: 'standard',
  VEGETARIAN: 'vegetarian',
  VEGAN: 'vegan',
  KOSHER: 'kosher',
  HALAL: 'halal',
  GLUTEN_FREE: 'gluten-free',
  DIABETIC: 'diabetic',
  NO_MEAL: 'no-meal'
};

// Special assistance options
export const SPECIAL_ASSISTANCE = [
  'Wheelchair assistance',
  'Mobility assistance',
  'Visual impairment assistance',
  'Hearing impairment assistance',
  'Traveling with infant',
  'Unaccompanied minor',
  'Pet in cabin',
  'Extra baggage assistance'
];

// Validation constants
export const VALIDATION = {
  EMAIL_REGEX: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE_REGEX: /^[\+]?[1-9][\d]{0,15}$/,
  PASSWORD_MIN_LENGTH: 8,
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 50
};